export default __webpack_public_path__ + "static/ThechefwhoputSloveniaonthemap-05276b7e2ca08537c3699b79f082c80c.jpg";